import { modalPadding, sectionalMargin } from "@iventis/styles/src/atomic-rules";
import { media, styled } from "@iventis/styles";
import { Header2 } from "@iventis/styles/src/components/texts";
import { Content } from "@iventis/translations/content/typed-content";
import { Button } from "@mui/material";
import React, { useState } from "react";

import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { CustomDialog } from "@iventis/components";
import { UserSearchComponent } from "./user-search";
import { GroupOption, UserOption } from "./user-search.types";

export const UserSearchModalComponent: React.FC<{ open: boolean; close: () => void; onSelected: (selection: GroupOption | UserOption) => void }> = ({
    open,
    close,
    onSelected,
}) => {
    const [selection, setSelection] = useState<GroupOption | UserOption>();
    const translate = useIventisTranslate();
    return (
        <CustomDialog open={open} onClose={close}>
            <StyledContainer>
                <Header2 style={{ marginBottom: sectionalMargin }}>{translate(Content.permissions.usersGroups.searchTitle)}</Header2>
                <StyledUserSearchComponent onSelected={(selection) => setSelection(selection)} />
                <StyledButtonsContainer>
                    <StyledButton color="primary" onClick={close}>
                        {translate(Content.common.buttons.cancel)}
                    </StyledButton>
                    <StyledButton
                        color="primary"
                        variant="contained"
                        disabled={!selection}
                        onClick={() => {
                            onSelected(selection);
                            setSelection(undefined);
                        }}
                        data-testid="confirm-user-or-group"
                    >
                        {translate(Content.common.buttons.confirm)}
                    </StyledButton>
                </StyledButtonsContainer>
            </StyledContainer>
        </CustomDialog>
    );
};

const StyledContainer = styled.div`
    padding: ${modalPadding};
`;

const StyledUserSearchComponent = styled(UserSearchComponent)`
    width: 100%;
`;

const StyledButtonsContainer = styled.nav`
    margin-top: ${modalPadding};
    display: flex;
    justify-content: flex-end;

    ${media.extraSmall} {
        justify-content: stretch;
    }
`;

const StyledButton = styled(Button)`
    margin-left: ${modalPadding};
    ${media.extraSmall} {
        margin-left: 0;
        flex: 1 0 50%;
    }
`;
